import CrudCustom from '../../../libs/custom/CrudCustom';

let BiayaPensiunService = new CrudCustom('/biaya-pensiuns');
export default BiayaPensiunService;
